<template>
  <div class="container-fluid">
    <div class="col-xs-12 title-container" v-if="titleActive">
      <div class="neon">Rockolify</div>
    </div>
    <div class="col-md-6 offset-md-3">
      <main-control @activePlaylistMode="activePlaylistMode"></main-control>
    </div>
  </div>
</template>

<script>
import MainControl from './MainControl'
export default {
  name: 'Application',
  components: {MainControl},
  data () {
    return {
      titleActive: true
    }
  },
  methods: {
    activePlaylistMode () {
      this.titleActive = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="scss" scoped >

  @font-face {
    font-family: neon;
    src: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/707108/neon.ttf);
  }
  .neon {
    font-family: neon;
    color: #41b883;
    font-size: 10vmax;
    line-height: 9rem;
    text-shadow: 0 0 3vw '#F40A35';
  }
  .neon {
    animation: neon 5s ease infinite;
    -moz-animation: neon 5s ease infinite;
    -webkit-animation: neon 5s ease infinite;
  }

  @keyframes neon {
    0%,
    100% {
      text-shadow: 0 0 1vw #41b883, 0 0 3vw #41b883, 0 0 10vw #41b883, 0 0 10vw #41b883, 0 0 .4vw #FED128, .5vw .5vw .1vw #806914;
      color: #38fe2a;
    }
    50% {
      text-shadow: 0 0 1vw #FA1C16, 0 0 3vw #FA1C16, 0 0 10vw #FA1C16, 0 0 10vw #FA1C16, 0 0 .4vw #FED128, .5vw .5vw .1vw #806914;
      color: #FED128;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Application.vue